import { render, staticRenderFns } from "./QuestionMatrixRate.vue?vue&type=template&id=0845b566&scoped=true&"
import script from "./QuestionMatrixRate.vue?vue&type=script&lang=js&"
export * from "./QuestionMatrixRate.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMatrixRate.vue?vue&type=style&index=0&id=0845b566&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0845b566",
  null
  
)

export default component.exports